import { teamSegmentGameModelGroup } from "../components/ClubDetail/Performance/GameModel"
import { IGameModel } from "../types/IClubDetail"
import * as d3 from "d3";

export const drawGameModelContours = (
    pitchGroup: d3.Selection<SVGGElement, any, null, undefined>,
    xScale: d3.ScaleLinear<number, number>,
    yScale: d3.ScaleLinear<number, number>,
    pitchWidth: number,
    pitchHeight: number,
    gameModelData: IGameModel[],
    tooltipRef: React.RefObject<HTMLDivElement>,
    selectedMatch?: number
) =>{
  //console.log("selectedMatch", selectedMatch)
        const tooltip = d3.select(tooltipRef.current);
        // console.log("from pitch",gameModelData?.flat())
        const allPoints = gameModelData?.map((group) =>
                group.latLongs.map((point) => ({
                  x: point.locationX,
                  y: point.locationY,
                  count: point.count,
                  type: group.name,
                }))
              );
        // console.log("allPoints", allPoints?.flat())

        const flatData = allPoints?.flat() || [];
        const colorMap: Record<string, string> = {};
        const labelMap: Record<string, string> = {};

        teamSegmentGameModelGroup.forEach(group => {
          group.Segments.forEach(segment => {
            colorMap[segment.key] = segment.color;
            labelMap[segment.key] = segment.label;
          });
        });

        Object.keys(colorMap).forEach(type => {
            const points = flatData.filter(d => d.type === type);
            if (points.length < 2) return;

            // console.log("points", points);
            // Density contours
            const density = d3.contourDensity<any>()
            .x(d => xScale(d.x))
            .y(d => yScale(d.y))
            .size([pitchWidth, pitchHeight])
            .bandwidth(20)
            .thresholds(15);

            const contours = density(points);

            const maxDensity = d3.max(contours, d => d.value) || 1;
            const cutoffPercent = selectedMatch !== 0 ? 0.2 : 0.5;
            const cutoff = maxDensity * cutoffPercent;

            const filteredContours = contours.filter(d => d.value >= cutoff);

            // Volcano color scale (from white to type color)
            const colorInterpolate = d3.interpolateRgb("white", colorMap[type]);

            pitchGroup.selectAll(`path.density-contour-${type}`)
            //.data(selectedMatch !== 0 ? contours : filteredContours)
            //.data(selectedMatch !== 0 ? filteredContours : filteredContours)
            .data(filteredContours )
            .enter()
            .append("path")
            .attr("class", `density-contour-${type}`)
            .attr("d", d3.geoPath())
            .attr("fill", (d, i) => colorInterpolate(i / (contours.length - 1)))
            .attr("stroke", colorMap[type])
            .attr("stroke-width", 1)
            .attr("opacity", 0.45)
            // .on("mouseover", function (event, d) {
            //     tooltip
            //     .style("opacity", 1)
            //     .html(
            //         `<strong>Density Contour: ${labelMap[type]}</strong><br/>Density: ${d.value.toFixed(4)}`
            //     );
            //     })
            //     .on("mousemove", function (event) {
            //         tooltip
            //         .style("left", event.pageX - 10 + "px")
            //         .style("top", event.pageY - 28 + "px");
            //     })
            //     .on("mouseout", function () {
            //         tooltip.style("opacity", 0);
            //     });
            });

}